// extracted by mini-css-extract-plugin
export default {"container":"tickets_container__BGfNZ","tickets":"tickets_tickets__TGudC","title":"tickets_title__z2rbE","description":"tickets_description__arif5","link":"tickets_link__LmeLB"};